module.exports = __webpack_public_path__ + "img/nfa-logo.19dc77e7.jpg";